exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-36c79a92]{margin-bottom:35px;border-bottom:2px solid #636363;border-radius:15px;box-shadow:0 5px #e2e2e2}.container-1[data-v-36c79a92]{text-align:center;display:inline-block;padding:50px;margin:auto}#name[data-v-36c79a92]{font-size:26px;font-weight:700;text-transform:capitalize}#email[data-v-36c79a92],#mobile [data-v-36c79a92],#name[data-v-36c79a92]{border-bottom:1px solid grey;border-left:3px solid grey;border-radius:8px}#email[data-v-36c79a92],#mobile [data-v-36c79a92]{font-size:22px}button[data-v-36c79a92]{font-size:18px;padding:5px;background-color:#ffcede;outline:none;border-radius:7px;margin:10px}button[data-v-36c79a92]:hover{background-color:#f098c0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36c79a92","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Profile.vue
// module id = 644
// module chunks = 0